import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VocabularyTerm } from 'lingo2-models';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameService } from './game.service';

@Injectable({
  providedIn: 'root',
})
export class VocabularyService {
  public term_language_id: number = 0;
  public definition_language_id: number = 0;
  public term_language_name: string = '';
  public definition_language_name: string = '';

  public currentVocabulary = new BehaviorSubject<Partial<VocabularyTerm>>({});
  public currentVocabulary$ = this.currentVocabulary.asObservable();

  public constructor(
    private http: HttpClient,
    private gameService: GameService,
  ) {
  }

  public createVocabularyTerm(term: Partial<VocabularyTerm>) {
    const url = `https://${this.gameService.host}/web/content/vocabulary/terms`;
    return this.http.post<VocabularyTerm>(url, term, { observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }

  public updateVocabularyTerm(id: string, term: Partial<VocabularyTerm>) {
    const url = `https://${this.gameService.host}/web/content/vocabulary/terms/${id}`;
    return this.http.put<VocabularyTerm>(url, term, { observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }
}
